"use client"

import { useState } from "react"
import { ChevronDown } from "lucide-react"

import { cn } from "../../lib/utils"

export type FaqItem = {
  question: string
  answer: string
}

type FaqAccordionProps = {
  items: FaqItem[]
  className?: string
}

export function FaqAccordion({ items, className }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <div className={cn("space-y-3", className)}>
      {items.map((item, index) => {
        const isOpen = openIndex === index
        return (
          <div
            key={item.question}
            className="overflow-hidden rounded-xl border border-white/10 bg-white/5"
          >
            <button
              type="button"
              className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-sm font-medium"
              onClick={() => setOpenIndex(isOpen ? null : index)}
            >
              {item.question}
              <ChevronDown
                className={cn(
                  "size-4 shrink-0 transition-transform",
                  isOpen && "rotate-180"
                )}
              />
            </button>
            {isOpen ? (
              <div className="border-t border-white/10 px-4 py-3 text-sm text-muted-foreground">
                {item.answer}
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
